__turbopack_context__.v({
  "bannerStripSlice": "BannerStripSlice-module-scss-module__Yg1TTq__bannerStripSlice",
});
